import { render, staticRenderFns } from "./DYSettle.vue?vue&type=template&id=b4c4a35c&scoped=true&"
import script from "./DYSettle.vue?vue&type=script&lang=js&"
export * from "./DYSettle.vue?vue&type=script&lang=js&"
import style0 from "./DYSettle.vue?vue&type=style&index=0&id=b4c4a35c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c4a35c",
  null
  
)

export default component.exports